export default{fetchingProperties:'Loading Properties...',propertyListTitle:'Object Information'};